import {gql} from "@apollo/client";

export const GET_PROPERTIES = gql`
    query GetProperties($pageIndex: Int!, $pageSize: Int!, $orderAsc: Boolean!, $orderField: String!, $filter: JSON) {
        properties(pagedInput: {
            pageInfo: {
                pageIndex: $pageIndex,
                pageSize: $pageSize
            },
            orderAsc: $orderAsc,
            orderField: $orderField,
            filter: $filter
          }) {
            items {
                id
                referenceNumber
                electricityMeterNumber
                address {
                    street
                    suburb
                    city
                    postalCode
                }
                status
                bedrooms
                bathrooms
                garages
                description
                landlord {
                    id
                    firstName
                    lastName
                }
                tenant {
                    id
                    firstName
                    lastName
                }
                agent {
                    id
                    firstName
                    lastName
                }
            }
            pageInfo {
                totalCount
                totalPages
                pageSize
                pageIndex
            }
        }
    }
`;

export const GET_DISTINCT_SUBURBS = gql`
    query GetDistinctSuburbs {
        distinctSuburbs
    }
`;

export const SEARCH_PROPERTIES = gql`
    query SearchProperties($searchTerm: String!) {
        searchProperties(searchTerm: $searchTerm) {
            id
            referenceNumber
            address {
                street
                suburb
                city
                province
                postalCode
            }
            status
            landlord {
                firstName
                lastName
            }
            tenant {
                firstName
                lastName
            }
        }
    }
`;

export const GET_PROPERTY = gql`
    query GetProperty($id: ID!) {
        property(id: $id) {
            id
            referenceNumber
            electricityMeterNumber
            address {
                street
                suburb
                city
                postalCode
            }
            status
            bedrooms
            bathrooms
            garages
            description
            submissionStatus
            rejectionReason
            landlord {
                id
                firstName
                lastName
            }
            tenant {
                id
                firstName
                lastName
            }
            agent {
                id
                firstName
                lastName
            }
            documents {
                id
                name
                type
                url
                uploadedAt
            }
            createdAt
            updatedAt
        }
    }
`;

export const CREATE_PROPERTY = gql`
    mutation CreateProperty($input: PropertyInput!) {
        createProperty(inputData: $input) {
            id
            referenceNumber
            electricityMeterNumber
            address {
                street
                suburb
                city
                province
                postalCode
            }
            status
            landlord {
                id
                firstName
                lastName
            }
            tenant {
                id
                firstName
                lastName
            }
            agent {
                id
                firstName
                lastName
            }
        }
    }
`;

export const UPDATE_PROPERTY = gql`
    mutation UpdateProperty($id: ID!, $input: PropertyInput!) {
        updateProperty(id: $id, inputData: $input) {
            id
            referenceNumber
            electricityMeterNumber
            address {
                street
                suburb
                city
                postalCode
            }
            status
            bedrooms
            bathrooms
            garages
            description
            landlord {
                id
                firstName
                lastName
            }
            tenant {
                id
                firstName
                lastName
            }
            agent {
                id
                firstName
                lastName
            }
        }
    }
`;

export const DELETE_PROPERTY = gql`
    mutation DeleteProperty($id: ID!) {
        deleteProperty(id: $id)
    }
`;

export const GET_PROPERTY_DOCUMENTS = gql`
    query GetPropertyDocuments($id: ID!) {
        property(id: $id) {
            id
            referenceNumber
            address {
                street
                suburb
                city
                postalCode
            }
            documents {
                id
                name
                type
                url
                uploadedAt
            }
        }
    }
`;

export const UPLOAD_PROPERTY_DOCUMENT = gql`
    mutation UploadPropertyDocument($propertyId: ID!, $file: Upload!, $type: String!) {
        uploadPropertyDocument(propertyId: $propertyId, file: $file, type: $type) {
            id
            name
            type
            url
            uploadedAt
        }
    }
`;

export const DELETE_PROPERTY_DOCUMENT = gql`
    mutation DeletePropertyDocument($id: ID!) {
        deletePropertyDocument(id: $id)
    }
`;

export const SUBMIT_PROPERTY = gql`
    mutation SubmitProperty($id: ID!) {
        submitProperty(id: $id) {
            id
            submissionStatus
            rejectionReason
        }
    }
`;

export const APPROVE_PROPERTY = gql`
    mutation ApproveProperty($id: ID!) {
        approveProperty(id: $id) {
            id
            submissionStatus
            rejectionReason
        }
    }
`;

export const REJECT_PROPERTY = gql`
    mutation RejectProperty($id: ID!, $reason: String!) {
        rejectProperty(id: $id, reason: $reason) {
            id
            submissionStatus
            rejectionReason
        }
    }
`;